module.exports = __webpack_public_path__ + "static/media/reports_conflicts_report.d3d43c38.mov";